namespace app.certification {

    import IHttpService = angular.IHttpService;
    import IPromise = angular.IPromise;
    import IHttpPromiseCallbackArg = angular.IHttpPromiseCallbackArg;
    import IQService = angular.IQService;

    export class SigningError {
        public constructor(public error: string) { }
    }

    export class PrepareCommand {
        public constructor(public certificateAsHex: string) { }
    }

    export class PreSignCommand {
        public constructor(public signerId: string) { }
    }

    export class ProvideToSignCommand {
        public constructor(public signerId: string, public documentId: number) { }
    }

    export class PostSignCommand {
        public constructor(public signerId: string, public signatureAsHex: string) { }
    }

    export interface SignerDto {
        signerId: string;
    }

    export interface PreSignatureDto {
        data: string;
        hash: string;
        hashType: string;
    }

    export interface SignedDocumentDto {
        documentId: string;
    }

    export class SignatureService {

        private static apiSignature: string = "api/assinadores";

        /** @ngInject **/
        public constructor(private properties, private $http: IHttpService, private $q: IQService,
                private cryptoService: CryptoService) {
        }

        prepare(command: PrepareCommand, context: string): IPromise<SignerDto> {
            let url = `${this.properties.apiUrl}/${context}/${SignatureService.apiSignature}`;

            return this.$http.post(url, command)
                .then((response: IHttpPromiseCallbackArg<SignerDto>) => response.data);
        }

        provideToSign(command: ProvideToSignCommand, context: string): IPromise<any> {
            let url = `${this.properties.apiUrl}/${context}/${SignatureService.apiSignature}` +
                `/${command.signerId}/associacao-documento`;

            return this.$http.post(url, command)
                .then(() => null);
        }

        preSign(command: PreSignCommand, context: string): IPromise<PreSignatureDto> {
            let url = `${this.properties.apiUrl}/${context}/${SignatureService.apiSignature}` +
                `/${command.signerId}/pre-assinatura`;

            return this.$http.post(url, command)
                .then((response: IHttpPromiseCallbackArg<PreSignatureDto>) => response.data);
        }

        postSign(command: PostSignCommand, context: string): IPromise<void> {
            let url = `${this.properties.apiUrl}/${context}/${SignatureService.apiSignature}` +
                `/${command.signerId}/pos-assinatura`;

            return this.$http.post(url, command)
                .then(() => null);
        }

        save(signerId: string, context: string): IPromise<SignedDocumentDto> {
            let url = `${this.properties.apiUrl}/${context}/${SignatureService.apiSignature}` +
                `/${signerId}/documento-assinado`;

            return this.$http.post(url, {})
                .then((response: IHttpPromiseCallbackArg<SignedDocumentDto>) => response.data);
        }

        signingManager(maximumParallelSignatures: number = 2, context: string) {
            return new SigningManager(this.$q, this.cryptoService, this, maximumParallelSignatures, context);
        }

    }

    angular.module("app.certification").service("signatureService", SignatureService);
}